<template>
  <div id="app">
    <!-- App Loader -->
    <div id="app-loader" :class="{'show': $store.state.settings.appLoader}">
      <h2>{{ $t('layout.appLoader') }}</h2>
    </div>
    <!-- END App Loader -->

    <section v-if="!appLoader">
      <section v-if="!jwt">
        <Login />
      </section>
      <section v-else>
        <router-view />
      </section>
    </section>
  </div>
</template>

<script>
import Login from "@/components/Login.vue";
import Auth from "@/store/auth";
import DbInit from "@/assets/js/DbInit";
import Store from "@/store";

export default {
  name: "App",
  created() {
    DbInit.sendInitRequest().then(result => {
      if (result === true) {
        Store.commit('appLoader', {mode: 'off'});
      }
    });

    let jwt = this.$cookies.get('token');

    if (jwt) {
      Auth.dispatch("setJwt", jwt);
    }
  },
  components: {
    Login
  },
  computed: {
    jwt() {
      return Auth.getters.getJwt;
    },
    appLoader() {
      return Store.state.settings.appLoader
    }
  }
};
</script>

<style lang="scss">
// Main Stylesheet
@import "./src/assets/scss/main";

// Bootstrap Vue Stylesheet
@import "~bootstrap-vue/src/index";

// All color themes are included and available by default
// Feel free to comment out any of them if you won"t use them in your project
@import "./src/assets/scss/oneui/themes/amethyst";
@import "./src/assets/scss/oneui/themes/city";
@import "./src/assets/scss/oneui/themes/flat";
@import "./src/assets/scss/oneui/themes/modern";
@import "./src/assets/scss/oneui/themes/smooth";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  .text-green {
    color: green !important;
  }

  .text-red {
    color: red !important;
  }

  .text-bold {
    font-weight: 600;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
